<template>

  <div class="pt-2">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">

              <label>Zapytaj o poradę dotyczącą ujęć, konkretnych zdjęć, wyboru oświetlenia itd:</label>

              <b-input-group>

                <b-form-input v-model="question" size="lg" ref="question" placeholder="np. Jak zrobić zdjęcie mojej żonie nad morzem?"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">

              <label>Wybierz mentora:</label>

              <b-input-group>

                <b-form-select v-model="mentor" ref="mentor" size="lg" :options="mentors"></b-form-select>

              </b-input-group>

            </div>
 
          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Poproś o poradę
          </b-button>

        </b-col>

      </b-row>



      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje poradę <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Porada</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">

            <div v-html="result" class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;"></div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>

        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>

    </div>

  </div>

</template>

<script>
import { languages } from './../../../../resources/languages.js';

export default {
  name: 'AppBussinesMentorAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      selectedText: '',
      query: "",
      lang: "Polski",
      languages,
      question: "",
      mentors: [
        "Ansel Adams – mistrz czarno-białych pejzaży, promotor ochrony przyrody",
        "Dorothea Lange – słynna za “Migrant Mother” w epoce Wielkiego Kryzysu",
        "Henri Cartier-Bresson – pionier fotografii reporterskiej",
        "Annie Leibovitz – jedna z najbardziej wpływowych portrecistek",
        "Steve McCurry – autor legendarnego „Afghan Girl”, wielokrotnie nagradzany",
        "Robert Capa – legenda fotografii wojennej.",
        "Diane Arbus – ikoniczna portrecistka marginesu społecznego", 
        "Yousuf Karsh – mistrz portretu z pierwszych stron magazynów",
        "Sebastião Salgado – brazylijski humanista",
        "Malick Sidibé – laureat Hasselblada",
        "Elliot Erwitt – wybitny fotograﬁk codzienności, psy i humor",
        "Philippe Halsman – kultowe portrety",
        "Carol Guzy – jedyna czwórkrotna laureatka Pulitzera",
        "Chris Hondros – finalista Pulitzera, odważny fotoreporter wojenny",
        "Felipe Dana – Pulitzer 2023, World Press Photo",
        "Horst Faas – dwukrotny Pulitzer, słynny fotograf wojenny",
        "Tom Franks – zwycięzca IPA Advertising Photographer of the Year",
        "Drew Gardner – zwycięzca IPA Analog/Film Photographer",
        "Gleici Rufatto – zwycięzca IPA Architecture Photographer",
        "Mustafa Hassona – IPA Editorial/Press Photographer of the Year",
        "Sebastian Copeland – IPA Book Photographer of the Year",
        "Charles “Chaz” Niell Jr. – IPA Event Photographer",
        "Paul Szimák – IPA Fine Art Photographer",
        "Benjamin Yavar – IPA Nature Photographer",
        "Maryam Firuzi – IPA People Photographer",
        "Dale May – IPA Special Photographer",
        "Peter Müller – IPA Sports Photographer",
        "Joanna Steidle – zwyciężczyni Aerial Photographer of the Year 2025",
        "Ignacio Palacios – „Photograph of the Year” Aerial Photographer 2025",
        "Thomas Vijayan – 3. miejsce w Aerial Photographer 2025"
      ],
      mentor: "",
      finishContent: '',
      selectedSchema: null
    }
  },
  methods: {

    generateFinish: function() {

      if(!this.mentor) return false;
      if(!this.question) return false;


      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""

      var query = "";

      query = "Wciel się w sposób myślenia znanego światowego fotografa " + this.mentor + " posiadaj jego wiedzę i doświadczenie i odpowiedz na pytanie: " + this.question + ". Zachowuj się jak mentor i edukuj i prowadź osobę która zadała pytanie. Odnieś się do stylu i doświadczenia " + this.mentor;
   
      var doneText = "";

      this.axios.post(window.API_URL + "text/generateFromAI/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {

        let data = response.data

        if(data.redirectTo) {

          top.location.href = data.redirectTo;

        }

        doneText = data.result;

        this.finishContent = doneText;

        this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

        this.$refs.generatePost.disabled = false
        this.generatedPostTitle = "Wygenerowany artykuł"

      }).catch(function() {

        this.$refs.generatePost.disabled = false

      })



    },

    copyResults: function() {

      this.$refs.finishContent.style.display = "block";

      this.$refs.finishContent.focus();

      document.execCommand('copy');

      this.$refs.finishContent.style.display = "none"

      window.scrollTo(0, 0)

      this.$bvToast.toast('Treść została skopiowana do schowka', {
        title: 'Skopiowano',
        autoHideDelay: 5000,
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })

    }

  },
  computed: {

  },
  created() {

    this.$watch('finishContent', (value) => {

      var lines = value.split(/\r|\r\n|\n/);

      this.finishLinesCount = lines.length;

    })

  },
  mounted() {

    if (localStorage.generators_language) {

      this.lang = localStorage.generators_language;

    } else {

      localStorage.generators_language = "Polski"
      this.lang = "Polski"
    }

  },
  watch: {

    lang(data) {

      localStorage.generators_language = data;

    }

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>
